import request from '@/utils/request'

// 获取客户人群及客户人群数据文件
export function customAudiencesList(params) {
  return request({
    url: '/ad1/customAudiences/get',
    method: 'get',
    params
  })
}
// 创建客户人群及客户人群数据文件
export function customAudiencesadd(data) {
  return request({
    url: `/ad1/customAudiences/add`,
    method: 'post',
    data
  })
}
export function customgetAdvertisers(params) {
  return request({
    url: '/ad1/customAudiences/getAdvertisers',
    method: 'get',
    params
  })
}
export function customAudiencesbinding(data) {
  return request({
    url: `/ad1/customAudiences/binding`,
    method: 'post',
    data
  })
}
export function customgetAdvertilist(params) {
  return request({
    url: '/ad1/customAudiences/getBindingList',
    method: 'get',
    params
  })
}
export function customAudiencesexportOpenid(data) {
  return request({
    url: `/ad1/customAudiences/exportOpenid`,
    method: 'post',
    data
  })
}
export function customgetAdvertipelist(params) {
  return request({
    url: '/ad1/customAudiences/getBindingList',
    method: 'get',
    params
  })
}
export function custombindingOfficialAccount(data) {
  return request({
    url: `/ad1/customAudiences/bindingOfficialAccount`,
    method: 'post',
    data
  })
}
export function screenOfficialist(params) {
  return request({
    url: '/ad1/customAudiences/screenOfficial',
    method: 'get',
    params
  })
}
export function screenStafflist(params) {
  return request({
    url: '/ad1/customAudiences/screenStaff',
    method: 'get',
    params
  })
}
export function custombindingOfficialAcc(data) {
  return request({
    url: `/ad1/customAudiences/delBindWechat`,
    method: 'post',
    data
  })
}

